import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { Chatbot } from "./Chatbot";
import { BackToTop } from "./BackToTop";

export function PublicLayout() {
  return (
    <div className="min-h-screen grain relative">
      <Navbar />
      <main className="relative z-[2]">
        <Outlet />
      </main>
      <Footer />
      <Chatbot />
      <BackToTop />
    </div>
  );
}
